<template>
  <v-dialog v-model="dialog" width="400">
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="createRouterosGroup">
      <v-card>
        <v-card-title class="headline">New Group</v-card-title>
        <v-card-text>
          <v-text-field v-model="item.name" label="Name" autofocus></v-text-field>
          <v-select
            v-model="item.address"
            :items="routerosIpAddress || []"
            :loading="loadingGateways"
            item-value="address"
            item-text="address"
            label="Address"
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.address }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.interface }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="loadingCreate"
            type="submit"
            :disabled="!item.name || !item.address"
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import fetch from '@/utils/fetch'
export default {
  name: 'MikrotikGroupDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    siteVpn: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      item: {
        name: null,
        address: null
      },
      routerosIpAddress: [],
      valid: true,
      loadingGateways: false,
      error: null,
      loadingCreate: false
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  mounted() {
    this.getRouterosGatewayIpAddress()
  },

  methods: {
    getRouterosGatewayIpAddress() {
      this.loadingGateways = true
      fetch(this.siteVpn['@id'] + '/routeros/gateways')
        .then(response => response.json())
        .then(data => {
          if (typeof data === 'object') {
            this.routerosIpAddress = Object.values(data)
          } else {
            this.routerosIpAddress = data
          }
          this.routerosIpAddress.forEach(item => {
            delete item.disabled
          })
        })
        .finally(() => {
          this.loadingGateways = false
        })
    },

    createRouterosGroup() {
      if (this.$refs.form.validate()) {
        this.loadingCreate = true
        fetch(this.siteVpn['@id'] + '/routeros/group', {
          method: 'POST',
          body: JSON.stringify(this.item)
        })
          .then(response => response.json())
          .then(data => {
            this.getRouterosGatewayIpAddress()
            this.$emit('created', data)
            this.dialog = false
          })
          .catch(e => {
            this.error = e
          })
          .finally(() => {
            this.loadingCreate = false
          })
      }
    }
  }
}
</script>
